import OtherBays from "./OtherBays";
export default OtherBays;
